import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { WIRELINE_REQUEST_TYPES_ID as WIRELINEREQUESTIDS } from '../../../../constants/external-constants';
import { valueExist } from '../../../../utils/helpers.utils';
import Translation from "../../../common/translation/translation.component";
import Icons from "../../../icon";
import { newCircuitSubscriptionActions } from "../../../../store/external/request-reducer/order-request-reducer/wireline-request/new-circuit/new-circuit-subscription.reducer";
import { requestDetailsActions } from "../../../../store/external/request-reducer/request-details.reducer";

class RequestOwnerDetails extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount(){
        const { resetNewApproverDetails, fetchWorkFlowApproverDetails } = this.props;
        resetNewApproverDetails();
        fetchWorkFlowApproverDetails();    
    }

    componentWillUnmount(){
        const {resetSelectRequest} = this.props; 

        resetSelectRequest();
    }
   
    isResetApprover() {
        const { typeId, wirelineTerminateCircuitRequest, wirelineChangeVendorRequest, wirelineUpgradeCircuitRequest, wirelineOtherRequestRequest } = this.props;
        const { isUpdateRequest } = this.props.createRequest;
        if (typeId === WIRELINEREQUESTIDS.terminateSubscriptionWireline && isUpdateRequest) {
            return wirelineTerminateCircuitRequest.isResetApprover;
        }
        else if (typeId === WIRELINEREQUESTIDS.wirelineChangeVendor && isUpdateRequest) {
            return wirelineChangeVendorRequest.isResetApprover;
        }
        else if (typeId === WIRELINEREQUESTIDS.updatePlanWireline && isUpdateRequest) {
            return wirelineUpgradeCircuitRequest.isResetApprover;
        }
        else if ((typeId === WIRELINEREQUESTIDS.wirelineUpgradeCircuit || typeId === WIRELINEREQUESTIDS.wirelineChangeLocationAddress || typeId === WIRELINEREQUESTIDS.wirelineOtherOther) && isUpdateRequest) {
            return wirelineOtherRequestRequest.isResetApprover;
        }

        return false;
    }

    renderManagerDisplay = (isWireline) => {
        const { approverWorkFlowData } = this.props;
        const { employeeList, requestOnBehalfData, isUpdateRequest } = this.props.createRequest;
        const { newUser } = this.props.wirelessChangeUserRequest
        const { newApproverDetails, isSearchNewApprover } = this.props.newCircuitRequest
        const { WireLineApprover } = this.props.requestData;
        let display;

        if (requestOnBehalfData.EmployeeId > 0 && Object.keys(newUser).length === 0) {
            if(isWireline)
            {
                if(newApproverDetails.length > 0) {
                    display =
                            <div>
                                <h6 className="owner-detail-info-title"><Translation translationKey="approver_details" /></h6>                    
                                <h5 className="owner-detail-info-owner-name">
                                    {newApproverDetails[0].LastFirstName}
                                </h5>
                                <div className="owner-detail-contacts">
                                    <Icons
                                        customClassName="icon-email"
                                        name="envelope"
                                        labelValue={newApproverDetails[0].EmailAddress ? newApproverDetails[0].EmailAddress : "N/A"}
                                        size="15px"
                                        containerClass="icon-container"
                                    />
                                        <Icons
                                        customClassName="icon-mobile"
                                        name="mobile-button"
                                        labelValue={newApproverDetails[0].PrimarySubscription ? newApproverDetails[0].PrimarySubscription : "N/A"}
                                        size="15px"
                                        containerClass="icon-container"
                                    />
                                    <Icons
                                        customClassName="icon-globe"
                                        name="globe"
                                        labelValue={newApproverDetails[0].Country ? newApproverDetails[0].Country : "N/A"}
                                        size="15px"
                                        containerClass="icon-container"
                                    />

                                    <Icons
                                        customClassName="icon-location"
                                        name="location-dot"
                                        labelValue={newApproverDetails[0].Location ? newApproverDetails[0].Location : "N/A"}
                                        size="15px"
                                        containerClass="icon-container"
                                    />
                                </div>
                    </div>;
                } 
                else if (isUpdateRequest && WireLineApprover && !this.isResetApprover())
                {
                    display =
                    <div>
                        <h6 className="owner-detail-info-title"><Translation translationKey="approver_details" /></h6>                    
                        <h5 className="owner-detail-info-owner-name">
                            {isSearchNewApprover ? newApproverDetails[0].LastFirstName : WireLineApprover.Name}
                        </h5>
                        <div className="owner-detail-contacts">
                            <Icons
                                customClassName="icon-email"
                                name="envelope"
                                labelValue={isSearchNewApprover ? (newApproverDetails[0].EmailAddress ? newApproverDetails[0].EmailAddress : "N/A") :
                                    (WireLineApprover.Email ? WireLineApprover.Email : "N/A")}
                                size="15px"
                                containerClass="icon-container"
                            />
                                <Icons
                                customClassName="icon-mobile"
                                name="mobile-button"
                                labelValue={isSearchNewApprover ? (newApproverDetails[0].PrimarySubscription ? newApproverDetails[0].PrimarySubscription : "N/A") :
                                    (WireLineApprover.PrimarySubscription ? WireLineApprover.PrimarySubscription : "N/A")}
                                size="15px"
                                containerClass="icon-container"
                            />
                            <Icons
                                customClassName="icon-globe"
                                name="globe"
                                labelValue={isSearchNewApprover ? (newApproverDetails[0].Country ? newApproverDetails[0].Country : "N/A") :
                                    (WireLineApprover.Location.CountryName ? WireLineApprover.Location.CountryName : "N/A") }
                                size="15px"
                                containerClass="icon-container"
                            />

                            <Icons
                                customClassName="icon-location"
                                name="location-dot"
                                labelValue={isSearchNewApprover ? (newApproverDetails[0].LocationSiteCityCountry ? newApproverDetails[0].LocationSiteCityCountry : "N/A") :
                                    (WireLineApprover.Location ? WireLineApprover.Location.LocationSite + " - " + WireLineApprover.Location.LocationCity + ", " + WireLineApprover.Location.CountryName  : "N/A")}
                                size="15px"
                                containerClass="icon-container"
                            />
                        </div>
                     </div>;
                } else {
                    display=null;
                }                
            } else {
                display =
                <div>
                    <h6 className="owner-detail-info-title"><Translation translationKey="approver_details" /></h6>
                    <h5 className="owner-detail-info-owner-name">
                        { (approverWorkFlowData && Object.keys(approverWorkFlowData ).length > 0) ? 
                            approverWorkFlowData?.LastName + ', ' + approverWorkFlowData?.FirstName + ' ' + (approverWorkFlowData?.MiddleInitial !== "" ? approverWorkFlowData?.MiddleInitial 
                                : "")   : 'N/A'  
                        }
                    </h5>
                    <div className="owner-detail-contacts">
                        <Icons
                            customClassName="icon-email"
                            name="envelope"
                            labelValue={
                                (approverWorkFlowData && Object.keys(approverWorkFlowData ).length > 0) ?
                                 approverWorkFlowData.Email:
                                    'N/A'
                            }
                            size="15px"
                            containerClass="icon-container"
                        />
                             <Icons
                            customClassName="icon-mobile"
                            name="mobile-button"
                            labelValue={(approverWorkFlowData && Object.keys(approverWorkFlowData ).length > 0) ?
                                  approverWorkFlowData.ContactNumber :
                                    'N/A'
                            }
                            size="15px"
                            containerClass="icon-container"
                        />
                        <Icons
                            customClassName="icon-globe"
                            name="globe"
                            labelValue={(approverWorkFlowData && Object.keys(approverWorkFlowData ).length > 0) ?
                                    approverWorkFlowData.CountryName :
                                    'N/A'
                            }
                            size="15px"
                            containerClass="icon-container"
                        />

                        <Icons
                            customClassName="icon-location"
                            name="location-dot"
                            labelValue={(approverWorkFlowData && Object.keys(approverWorkFlowData ).length > 0) ?
                                    approverWorkFlowData?.LocationSite + " - " + approverWorkFlowData?.LocationCity + ", " + approverWorkFlowData?.CountryName :
                                    'N/A'
                            }
                            size="15px"
                            containerClass="icon-container"
                        />
                    </div>
                </div>;
            }
            
        } else {  
            if(isWireline) {
                if ((WireLineApprover || (newApproverDetails && newApproverDetails.length > 0)) && !this.isResetApprover()) {
                    display =
                        <div>
                            <h6 className="owner-detail-info-title"><Translation translationKey="approver_details" /></h6>                    
                            <h5 className="owner-detail-info-owner-name">
                                {isSearchNewApprover ? newApproverDetails[0].LastFirstMiddleName : WireLineApprover.Name}
                            </h5>
                            <div className="owner-detail-contacts">
                                <Icons
                                    customClassName="icon-email"
                                    name="envelope"
                                    labelValue={isSearchNewApprover ? (newApproverDetails[0].EmailAddress ? newApproverDetails[0].EmailAddress : "N/A") :
                                                (WireLineApprover.Email ? WireLineApprover.Email : "N/A")}
                                    size="15px"
                                    containerClass="icon-container"
                                />
                                    <Icons
                                    customClassName="icon-mobile"
                                    name="mobile-button"
                                    labelValue={isSearchNewApprover ? (newApproverDetails[0].PrimarySubscription ? newApproverDetails[0].PrimarySubscription : "N/A") :
                                                (WireLineApprover.PrimarySubscription ? WireLineApprover.PrimarySubscription : "N/A")}
                                    size="15px"
                                    containerClass="icon-container"
                                />
                                <Icons
                                    customClassName="icon-globe"
                                    name="globe"
                                    labelValue={isSearchNewApprover ? (newApproverDetails[0]?.Country ? newApproverDetails[0]?.Country : "N/A") :
                                                (WireLineApprover.Location?.CountryName ? WireLineApprover.Location?.CountryName : "N/A") }
                                    size="15px"
                                    containerClass="icon-container"
                                />

                                <Icons
                                    customClassName="icon-location"
                                    name="location-dot"
                                    labelValue={isSearchNewApprover ? (newApproverDetails[0].LocationSiteCityCountry ? newApproverDetails[0].LocationSiteCityCountry : "N/A") :
                                        (WireLineApprover.Location ? WireLineApprover.Location.LocationSite + " - " + WireLineApprover.Location.LocationCity + ", " + WireLineApprover.Location.CountryName  : "N/A")}

                                    size="15px"
                                    containerClass="icon-container"
                                />
                            </div>
                </div>;
                } else {
                    display=null
                }
            }  else {
                display =
                <div>
                    <h6 className="owner-detail-info-title"><Translation translationKey="approver_details" /></h6>                    
                    <h5 className="owner-detail-info-owner-name">
                    {approverWorkFlowData && Object.keys(approverWorkFlowData).length > 0 
                        ? `${approverWorkFlowData?.LastName}, ${approverWorkFlowData?.FirstName} ${approverWorkFlowData?.MiddleInitial !== "" ? approverWorkFlowData?.MiddleInitial : ""}`
                        : Object.keys(newUser).length > 0 
                            ? newUser.CostCodeApproverFullName || ""  
                            : "N/A"
                    }
                    </h5>
                    <div className="owner-detail-contacts">
                            <Icons
                                customClassName="icon-email"
                                name="envelope"
                                labelValue={approverWorkFlowData && Object.keys(approverWorkFlowData).length > 0 
                                    ? approverWorkFlowData.Email 
                                    : Object.keys(newUser).length > 0 
                                        ? newUser.CostCodeApproverEmailAddress || "N/A" 
                                        : "N/A"
                                }
                                size="15px"
                                containerClass="icon-container"
                            />
                            <Icons
                                customClassName="icon-mobile"
                                name="mobile-button"
                                labelValue={approverWorkFlowData && Object.keys(approverWorkFlowData).length > 0 
                                    ? approverWorkFlowData.PrimarySubscription 
                                    : Object.keys(newUser).length > 0 
                                        ? newUser.CostCodeApproverContatcNum || "N/A" 
                                        : "N/A"
                                }
                                size="15px"
                                containerClass="icon-container"
                            />
                            <Icons
                                customClassName="icon-globe"
                                name="globe"
                                labelValue={approverWorkFlowData && Object.keys(approverWorkFlowData).length > 0 
                                    ? approverWorkFlowData.CountryName 
                                    : Object.keys(newUser).length > 0 
                                        ? newUser.CostCodeApproverLocation?.CountryName || "N/A" 
                                        : "N/A"
                                }
                                size="15px"
                                containerClass="icon-container"
                            />

                            <Icons
                                customClassName="icon-location"
                                name="location-dot"
                                labelValue={approverWorkFlowData && Object.keys(approverWorkFlowData).length > 0 
                                    ? `${approverWorkFlowData?.LocationSite} - ${approverWorkFlowData?.LocationCity}, ${approverWorkFlowData?.CountryName}`
                                    : Object.keys(newUser).length > 0 
                                        ? `${newUser.CostCodeApproverLocation?.LocationSite} - ${newUser.CostCodeApproverLocation?.LocationCity}, ${newUser.CostCodeApproverLocation?.CountryName}` 
                                        : "N/A"
                                }
                                size="15px"
                                containerClass="icon-container"
                            />
                        </div>
                </div>;
            }       
            
        }

        return display;
    }

    renderRequesterDisplay = () => { 
        const { data,typeId } = this.props;
        const { requestOnBehalfData, employeeList } = this.props.createRequest;
        const { newUser } = this.props.wirelessChangeUserRequest
        let display;
        if (requestOnBehalfData.EmployeeId > 0 && Object.keys(newUser).length === 0) {
            display =
                <div>
                    <h5 className="owner-detail-info-owner-name">
                        {requestOnBehalfData.LastFirstName}
                    </h5>
                    <div className="owner-detail-contacts">
                        <Icons
                            customClassName="icon-email"
                            name="envelope"
                            labelValue={requestOnBehalfData.EmailAddress != null ? requestOnBehalfData.EmailAddress: "N/A"}
                            size="15px"
                            containerClass="icon-container"
                        />
                        <Icons
                            customClassName="icon-mobile"
                            name="mobile-button"
                            labelValue={requestOnBehalfData.PrimarySubscription != null ?
                                requestOnBehalfData.PrimarySubscription :
                                employeeList !== null && employeeList.length > 0 ?
                                employeeList[0].PrimarySubscription !== null ?
                                    employeeList[0].PrimarySubscription :
                                    'N/A' :
                                "N/A"}
                            size="15px"
                            containerClass="icon-container"
                        />
                        <Icons
                            customClassName="icon-globe"
                            name="globe"
                            labelValue={requestOnBehalfData.Country != null ? requestOnBehalfData.Country : "N/A"}
                            size="15px"
                            containerClass="icon-container"
                        />

                        <Icons
                            customClassName="icon-location"
                            name="location-dot"
                            labelValue={requestOnBehalfData.LocationModel != null ?
                                requestOnBehalfData.LocationModel.LocationSite + " - " + requestOnBehalfData.LocationModel.LocationCity + ", " + requestOnBehalfData.Country :
                                employeeList !== null && employeeList.length > 0 && employeeList[0].LocationModel !== null ?
                                    employeeList[0].LocationModel.LocationSite + " - " + employeeList[0].LocationModel.LocationCity + ", " + employeeList[0].LocationModel.CountryName :
                                    'N/A'
                            }
                            size="15px"
                            containerClass="icon-container"
                        />
                    </div>
                </div>;
        } else {            
            display =
                <div>                   
                    <h5 className="owner-detail-info-owner-name">
                        {newUser.LastFirstName ?? `${data.LastName}, ${data.FirstName}`}
                    </h5>
                    <div className="owner-detail-contacts">
                        <Icons
                            customClassName="icon-email"
                            name="envelope"
                            labelValue={newUser.EmailAddress ? newUser.EmailAddress: data.Email}
                            size="15px"
                            containerClass="icon-container"
                        />
                        <Icons
                            customClassName="icon-mobile"
                            name="mobile-button"
                            labelValue={newUser.PrimarySubscription ? newUser.PrimarySubscription != null ? newUser.PrimarySubscription : "N/A" : data.PrimarySubscription != null ? data.PrimarySubscription : "N/A"}
                            size="15px"
                            containerClass="icon-container"
                        />
                        <Icons
                            customClassName="icon-globe"
                            name="globe"
                            labelValue={newUser.Country ? newUser.Country != null ? newUser.Country : "N/A" : data.Location != null ? data.Location.CountryName : "N/A"}
                            size="15px"
                            containerClass="icon-container"
                        />

                        <Icons
                            customClassName="icon-location"
                            name="location-dot"
                            labelValue={newUser.LocationSiteCityCountry ? newUser.LocationSiteCityCountry != null ? newUser.LocationSiteCityCountry : "N/A" : data.Location != null ? data.Location.LocationSite + " - " + data.Location.LocationCity + ", " + data.Location.CountryName : "N/A"}
                            size="15px"
                            containerClass="icon-container"
                        />
                    </div>
                </div>;
        }

        return display;
    }

    render() {
        const { isLoading, typeId } = this.props;

        let isWireline = valueExist(WIRELINEREQUESTIDS, typeId);

        return (
            !isLoading ?
                <div className="owner-detail-info owner-detail-container">
                    <h6 className="owner-detail-info-title"><Translation translationKey="request_owner_details" /></h6>
                    {this.renderRequesterDisplay()}
                    {this.renderManagerDisplay(isWireline)}
                </div> : <div></div>
        );
    }
}

export default connect(
    state => {
        const { requestDetail, createRequest, wirelessChangeUserRequest, wirelineTerminateCircuitRequest, wirelineChangeVendorRequest, wirelineUpgradeCircuitRequest, wirelineOtherRequestRequest, newCircuitRequest, adminSetting } = state;
        return {
            ...requestDetail
            , createRequest
            , wirelessChangeUserRequest
            , wirelineTerminateCircuitRequest
            , wirelineChangeVendorRequest
            , wirelineUpgradeCircuitRequest
            , wirelineOtherRequestRequest
            , newCircuitRequest
            , adminSetting
        };
    },
    dispatch =>
       bindActionCreators(
        Object.assign({}, newCircuitSubscriptionActions, requestDetailsActions),
        dispatch
       )
)(RequestOwnerDetails);